import { render, staticRenderFns } from "./SurveyBuilderEngineSurvey.vue?vue&type=template&id=3cb3facb&scoped=true"
import script from "./SurveyBuilderEngineSurvey.vue?vue&type=script&lang=js"
export * from "./SurveyBuilderEngineSurvey.vue?vue&type=script&lang=js"
import style0 from "./SurveyBuilderEngineSurvey.vue?vue&type=style&index=0&id=3cb3facb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb3facb",
  null
  
)

export default component.exports